import React from "react";

const VectorLine = () => {
  return (
    <>
      <svg
        width="45"
        height="4"
        viewBox="0 0 45 4"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.703613"
          y="0.187012"
          width="44.23"
          height="3.06544"
          rx="1.53272"
          fill="url(#paint0_linear_1_63)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1_63"
            x1="22.8186"
            y1="0.187012"
            x2="22.8186"
            y2="3.25245"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#0CD8AE" />
            <stop offset="1" stop-color="#0CD845" />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
};

export default VectorLine;
